import $ from 'jquery';
import isViewport from '../../scripts/util/window/isViewport';
import detectOS from '../../scripts/util/detect/detectOS';
import {lg} from '../../scripts/util/window/isViewport';
import {win} from '../../scripts/util/detect/detectOS';

export default class History {
	constructor() {
		this.selectors = {
			items: '.js-history-items',
			item: '.js-history-item',
			share: '.js-history-share',
			more: '.js-history-more',
			arrow: '.js-icon-arrow'
		};

		this.states = {
			hidden: 'hidden',
			visible: 'visible',
			indent: {
				more: 'toggle__icon_indent_more'
			},
			button: {
				noHover: 'history__button_hover_disable'
			}
		};

		this.maxItems = {
			desktop: 8,
			mobile: 6,
			add: 5
		};

		this.$el = $(this.selectors.items);
		this.$window = $(window);
		this.$document = $(document);
	}

	getElements = () => {
		this.$items = this.$el.find(this.selectors.item);
		this.$more = $(this.selectors.more);
		this.$share = $(this.selectors.share);
		this.$arrow = $(this.selectors.arrow);
	}

	checkCount = () => {
		if (!isViewport(lg)) {
			this.hide(this.maxItems.desktop);
		} else {
			this.hide(this.maxItems.mobile);
		}
	}

	hide = number => {
		const hidden = this.states.hidden;
		this.$items.slice(number).addClass(hidden);
		this.$items.slice(0, number).removeClass(hidden);
	}

	showMore = () => {
		const $hiddenItems = this.$el.find(`.${this.states.hidden}`);
		$hiddenItems.slice(0, this.maxItems.add).removeClass(this.states.hidden);
		this.$el.attr('data-edit', true);
		this.showShare();
	}

	showShare = () => {
		const length = this.$el.find(`.${this.states.hidden}`).length;
		const hidden = this.states.hidden;
		if (!length) {
			this.$more.addClass(hidden);
			this.$share.removeClass(hidden);
		}
	}

	correctArrow = () => {
		if (detectOS(win)) {
			this.$arrow.addClass(this.states.indent.more);
		}
	}

	onLoad = () => {
		this.checkCount();
		this.showShare();
	}

	onResize = () => {
		const isEdit = this.$el.attr('data-edit');
		if (isEdit === 'false') {
			this.checkCount();
		}
	}

	render = () => {
		if (this.$el.length) {
			this.getElements();
			this.$window.on('load', this.onLoad);
			this.$window.on('resize', this.onResize);
			this.$more.on('click', this.showMore);
			this.correctArrow();
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/history/index.js
 **/